import { useCallback, useEffect, useState } from "react"
import {
  ApiError,
  fitnessOnDemandCheckToken,
  gympassPrecheckActivate,
  promoLinkCheckToken,
} from "./api"
import { Screen } from "./App"
import { useT } from "@transifex/react"

export const TokenCheckScreen = ({
  gympassToken,
  fitnessOnDemandToken,
  promoLinkToken,
  onComplete,
  onFailure,
}: {
  gympassToken: string | undefined
  fitnessOnDemandToken: string | undefined
  promoLinkToken: string | undefined
  onComplete: (nextScreen: Screen) => void
  onFailure: (nextScreen: Screen, errorMessage?: string) => void
}) => {
  const t = useT()
  const [loading, setLoading] = useState(false)
  const checkToken = useCallback(async () => {
    setLoading(true)
    try {
      if (gympassToken) {
        await gympassPrecheckActivate(gympassToken)
        onComplete(Screen.Email)
      } else if (fitnessOnDemandToken) {
        await fitnessOnDemandCheckToken(fitnessOnDemandToken)
        onComplete(Screen.Email)
      } else if (promoLinkToken) {
        await promoLinkCheckToken(promoLinkToken)
        onComplete(Screen.Email)
      } else {
        throw new Error("Bug: pass a token")
      }
    } catch (error) {
      if (error instanceof ApiError) {
        onFailure(Screen.Failed, error.message)
      } else {
        onFailure(Screen.Failed)
      }
    } finally {
      setLoading(false)
    }
  }, [
    gympassToken,
    fitnessOnDemandToken,
    promoLinkToken,
    onComplete,
    onFailure,
  ])

  useEffect(() => {
    if (gympassToken || fitnessOnDemandToken || promoLinkToken) {
      checkToken()
    }
  }, [gympassToken, fitnessOnDemandToken, promoLinkToken, checkToken])

  return (
    <>
      <p className="App-description">{t("Validating token.")}</p>
      {loading && <div className="loader" />}
    </>
  )
}
